/** 空间客服消息本地缓存配置 */
export const CS_MESSAGE_CACHE = {
  version: 1,
  keyPrefix: "lf.spaceCs",
  maxItems: 200,
  initialVisible: 50,
} as const;
